export const DEV_PLATFORM_URL =
  'https://dev.platform.dacoval.com';
export const QA_PLATFORM_URL =
  'https://qa.platform.dacoval.com';
export const UAT_PLATFORM_URL =
  'https://uat.platform.dacoval.com';
export const PROD_PLATFORM_URL = 'https://platform.dacoval.com';

export const DEV_PLATFORM_API_URL =
  'https://dev-backend.platform.dacoval.com/dmint-platform/api';
export const QA_PLATFORM_API_URL =
  'https://qa-backend.platform.dacoval.com/dmint-platform/api';
export const UAT_PLATFORM_API_URL =
  'https://uat-backend.platform.dacoval.com/dmint-platform/api';
export const PROD_PLATFORM_API_URL = 'https://backend.platform.dacoval.com/dmint-platform/api';


export interface Dataview {
  viewId: number;
  viewName: string;
  viewDescription: string;
  assignedAccessGroups: any[];
  assignedTags: any[];
  viewFields: any[];
  tags: any[];
  createdOn: string;
  lastMod: string;
}
